import { useEffect, useState } from 'preact/hooks';
import { MainLayout } from '../../components/MainLayout';
import { AgentConnectionsManager } from '../../features/connections/components/AgentConnectionsManager';

export function AgentSettingsPage({ agentId }: { agentId: string }) {
  const [activeTab, setActiveTab] = useState<'model' | 'connections'>('model');

  // Read ?tab=connections from URL on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tab') === 'connections') {
      setActiveTab('connections');
    }
  }, []);

  // TODO: Replace with real agent settings from API
  const dummySettings = {
    model: 'gpt-4',
    temperature: 0.7,
    maxTokens: 2000,
    systemPrompt: 'You are a helpful assistant.',
    tools: ['web-search', 'calculator', 'code-interpreter'],
  };

  return (
    <MainLayout>
      <div class="flex-1 overflow-auto">

      <div class="container mx-auto p-8 max-w-4xl">
        {/* Tab Navigation */}
        <div class="tabs tabs-boxed mb-6">
          <a
            class={`tab ${activeTab === 'model' ? 'tab-active' : ''}`}
            onClick={() => setActiveTab('model')}
          >
            Model Settings
          </a>
          <a
            class={`tab ${activeTab === 'connections' ? 'tab-active' : ''}`}
            onClick={() => setActiveTab('connections')}
          >
            Connections & Tools
          </a>
        </div>

        {activeTab === 'model' && (
          <div class="grid gap-6">
          {/* Model Settings */}
          <div class="card bg-base-200">
            <div class="card-body">
              <h2 class="card-title">Model Configuration</h2>

              <div class="form-control">
                <label class="label">Model</label>
                <select class="select select-bordered" value={dummySettings.model}>
                  <option>gpt-4</option>
                  <option>gpt-3.5-turbo</option>
                  <option>claude-3</option>
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  Temperature: {dummySettings.temperature}
                </label>
                <input
                  type="range"
                  min="0"
                  max="1"
                  value={dummySettings.temperature}
                  step="0.1"
                  class="range"
                />
              </div>

              <div class="form-control">
                <label class="label">Max Tokens</label>
                <input
                  type="number"
                  value={dummySettings.maxTokens}
                  class="input input-bordered"
                />
              </div>
            </div>
          </div>

          {/* System Prompt */}
          <div class="card bg-base-200">
            <div class="card-body">
              <h2 class="card-title">System Prompt</h2>
              <textarea
                class="textarea textarea-bordered h-32"
                value={dummySettings.systemPrompt}
              />
            </div>
          </div>

          {/* Tools */}
          <div class="card bg-base-200">
            <div class="card-body">
              <h2 class="card-title">Available Tools</h2>
              <div class="space-y-2">
                {dummySettings.tools.map((tool) => (
                  <label key={tool} class="flex items-center gap-2">
                    <input type="checkbox" checked class="checkbox" />
                    <span>{tool}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Actions */}
          <div class="flex gap-4">
            <button class="btn btn-primary" disabled>
              Save Settings (TODO)
            </button>
            <button class="btn btn-ghost">Cancel</button>
          </div>

          <div class="alert alert-info">
            <span>TODO: Connect to real agent settings API</span>
          </div>
        </div>
        )}

        {activeTab === 'connections' && (
          <AgentConnectionsManager agentId={agentId} />
        )}
      </div>
      </div>
    </MainLayout>
  );
}
